import React, { createContext, useContext, useState, useCallback } from 'react';
import { Snackbar, Alert } from '@mui/material';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

const ToastProvider = ({ children }) => {
  const [toastState, setToastState] = useState({
    open: false,
    message: '',
    severity: 'info', 
  });

  const showToast = useCallback((message, severity = 'info') => {
    setToastState({ open: true, message, severity });
  }, []);

  const closeToast = () => setToastState((prev) => ({ ...prev, open: false }));

  // Utility methods
  const toast = {
    success: (message) => showToast(message, 'success'),
    error: (message) => showToast(message, 'error'),
    warning: (message) => showToast(message, 'warning'),
    info: (message) => showToast(message, 'info'),
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <Snackbar
        open={toastState.open}
        autoHideDuration={3000}
        onClose={closeToast}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={closeToast} severity={toastState.severity} sx={{ width: '100%' }}>
          {toastState.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};

export default ToastProvider;
